export const COMPANY_QUERY_TOKEN_PARAM = 'companyToken'
export const GIFT_CODE_QUERY_TOKEN_PARAM = 'amazonCode'
export const REAUTH_QUERY_TOKEN_PARAM = 'reAuthToken'
export const TOKEN_QUERY_PARAM = 'token'
export const INSTALLATION_INVITATION_TOKEN_QUERY_PARAM = 'installation-invitation-token'
export const CHANGE_EMAIL_QUERY_PARAM = 'email-change-token'
export const CHANGE_EMAIL_AND_USERNAME_QUERY_PARAM = 'username-change-token'
export const SEARCH_QUERY_PARAM = 'filter'
export const PAGE_QUERY_PARAM = 'page'
export const SORT_QUERY_PARAM = 'sort'
export const PROTECTED_FILE_QUERY_PARAM = 'file'

export const REDIRECT_URL_KEY = 'redirect-url-after-login'
export const REDIRECT_QUERY_PARAM = 'redirect-url-search-after-login'

export enum BottomBarPosition {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
}
